import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import NextImage from 'next/image';
import type { HeroBannerBlock } from '../types';
import { RichSegments } from './RichSegments';
import styles from './HeroBanner.module.css';
interface HeroBannerProps {
  block: HeroBannerBlock;
  blockId: string;
}
const DEFAULT_GRADIENT = 'linear-gradient(to top right, rgba(27, 80, 120, 0.6), rgba(235, 131, 34, 0.6))';
export function HeroBanner(t0) {
  const $ = _c(40);
  const {
    block,
    blockId
  } = t0;
  const ctaPlacement = block.ctaPlacement ?? "inline";
  const overlay = block.gradientOverlay ?? DEFAULT_GRADIENT;
  const t1 = block.backgroundImage ? `${overlay}, url('${block.backgroundImage}')` : undefined;
  const t2 = block.minHeight ?? "500px";
  let t3;
  if ($[0] !== block.backgroundColor || $[1] !== t1 || $[2] !== t2) {
    t3 = {
      backgroundImage: t1,
      backgroundColor: block.backgroundColor,
      minHeight: t2
    };
    $[0] = block.backgroundColor;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const inlineStyle = t3;
  const alignClass = block.align === "center" ? styles.centerAlign : styles.leftAlign;
  const layoutClass = block.layout === "split" ? styles.splitHero : null;
  let t4;
  if ($[4] !== alignClass || $[5] !== layoutClass) {
    t4 = [styles.hero, alignClass, layoutClass].filter(Boolean);
    $[4] = alignClass;
    $[5] = layoutClass;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const className = t4.join(" ");
  let t5;
  if ($[7] !== block.breadcrumbs) {
    t5 = block.breadcrumbs.length > 0 ? <nav aria-label="Breadcrumb" className={styles.breadcrumbs}><ol className={styles.breadcrumbList}>{block.breadcrumbs.map(_temp)}</ol></nav> : null;
    $[7] = block.breadcrumbs;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== block.eyebrow) {
    t6 = block.eyebrow ? <span className={styles.eyebrow}>{block.eyebrow}</span> : null;
    $[9] = block.eyebrow;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = block.headingLevel ?? 1;
  let t8;
  if ($[11] !== block.heading || $[12] !== t7) {
    t8 = <HeroHeading level={t7}>{block.heading}</HeroHeading>;
    $[11] = block.heading;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== block || $[15] !== ctaPlacement) {
    t9 = block.subtitle && block.subtitle.length > 0 ? <p className={styles.subtitle} data-cms-field="paragraph"><RichSegments segments={block.subtitle} />{block.cta && ctaPlacement === "inline" ? <><br /><br />{" "}<CtaLink block={block} inline={true} /></> : null}</p> : null;
    $[14] = block;
    $[15] = ctaPlacement;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== block.body) {
    t10 = block.body?.map(_temp2);
    $[17] = block.body;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== block || $[20] !== ctaPlacement) {
    t11 = block.cta && (!block.subtitle || block.subtitle.length === 0 || ctaPlacement === "below") ? <CtaLink block={block} /> : null;
    $[19] = block;
    $[20] = ctaPlacement;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t5 || $[25] !== t6 || $[26] !== t8 || $[27] !== t9) {
    t12 = <div className={styles.copy}>{t5}{t6}{t8}{t9}{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t5;
    $[25] = t6;
    $[26] = t8;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== block.mediaImage) {
    t13 = block.mediaImage ? <div className={styles.media}>{block.mediaImage.width && block.mediaImage.height ? <NextImage src={block.mediaImage.src} alt={block.mediaImage.alt} width={block.mediaImage.width} height={block.mediaImage.height} className={styles.mediaImage} priority={true} /> : <img src={block.mediaImage.src} alt={block.mediaImage.alt} className={styles.mediaImage} loading="eager" />}</div> : null;
    $[29] = block.mediaImage;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t12 || $[32] !== t13) {
    t14 = <div className={styles.container}>{t12}{t13}</div>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== block.id || $[35] !== blockId || $[36] !== className || $[37] !== inlineStyle || $[38] !== t14) {
    t15 = <section id={block.id} className={className} style={inlineStyle} data-cms-block-id={blockId} data-cms-field="heroBanner">{t14}</section>;
    $[34] = block.id;
    $[35] = blockId;
    $[36] = className;
    $[37] = inlineStyle;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
}
function _temp2(paragraph, idx_0) {
  return <p key={idx_0} className={styles.bodyParagraph} data-cms-field="paragraph"><RichSegments segments={paragraph} /></p>;
}
function _temp(crumb, idx) {
  return <li key={idx} className={styles.breadcrumbItem}>{crumb.href && !crumb.current ? <a href={crumb.href} className={styles.breadcrumbLink}>{crumb.label}</a> : <strong className={styles.breadcrumbCurrent}>{crumb.label}</strong>}</li>;
}
function HeroHeading(t0) {
  const $ = _c(8);
  const {
    level,
    children
  } = t0;
  switch (level) {
    case 2:
      {
        let t1;
        if ($[0] !== children) {
          t1 = <h2 className={styles.heading}>{children}</h2>;
          $[0] = children;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case 3:
      {
        let t1;
        if ($[2] !== children) {
          t1 = <h3 className={styles.heading}>{children}</h3>;
          $[2] = children;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case 4:
      {
        let t1;
        if ($[4] !== children) {
          t1 = <h4 className={styles.heading}>{children}</h4>;
          $[4] = children;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case 1:
    default:
      {
        let t1;
        if ($[6] !== children) {
          t1 = <h1 className={styles.heading}>{children}</h1>;
          $[6] = children;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
  }
}
function CtaLink(t0) {
  const $ = _c(10);
  const {
    block,
    inline: t1
  } = t0;
  const inline = t1 === undefined ? false : t1;
  if (!block.cta) {
    return null;
  }
  const t2 = `${styles.cta} ${block.cta.variant === "secondary" ? styles.ctaSecondary : styles.ctaPrimary}`;
  let t3;
  if ($[0] !== block.cta.label) {
    t3 = <span className={styles.ctaButton}>{block.cta.label}</span>;
    $[0] = block.cta.label;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== block.cta.href || $[3] !== block.cta.rel || $[4] !== block.cta.target || $[5] !== t2 || $[6] !== t3) {
    t4 = <a href={block.cta.href} target={block.cta.target} rel={block.cta.rel} className={t2}>{t3}</a>;
    $[2] = block.cta.href;
    $[3] = block.cta.rel;
    $[4] = block.cta.target;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const link = t4;
  if (inline) {
    return link;
  }
  let t5;
  if ($[8] !== link) {
    t5 = <p className={styles.ctaParagraph}>{link}</p>;
    $[8] = link;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}